import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthorization } from 'hooks';
import { Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import NotesIcon from '@mui/icons-material/Notes';
import SearchIcon from '@mui/icons-material/Search';
import { Button, Card, IconButton, TextField } from '@totalsoft/rocket-ui';
import PropTypes from 'prop-types';
import CommentContainer from './CommentContainer';
import { emptyString } from 'constants/defaultValues';
import InsuranceDataContext from 'features/insuranceDocument/stepper/insuranceDataContext';
import AuthorizationCodes from 'features/common/constants/authorizationCodes';
import { CommentsWrapper } from './CommentStyles';

const CommentsComponent = ({ comments, filter, adding, processing, onAdd, onSave, onDelete, onUpdateFilter, readOnly }) => {
  const { documentTypeId, documentStateId } = useContext(InsuranceDataContext);
  const hasRightToAddComment = useAuthorization(AuthorizationCodes.hasRightToAddComment, documentTypeId, documentStateId);
  const { t } = useTranslation();

  return (
    <Card id='CommentsComponent_IconCard' icon={NotesIcon} title={t('Offer.Edit.Comments.Title')}>
      <Grid container spacing={3} justifyContent={'flex-end'}>
        <Grid item container xs={12} md={6}>
          <TextField
            fullWidth
            onChange={onUpdateFilter}
            label={t('General.Search')}
            value={filter || emptyString}
            inputProps={{
              maxLength: 255
            }}
            startAdornment={<SearchIcon />}
            endAdornment={
              <IconButton
                size='small'
                variant='text'
                color='primary'
                onClick={() => onUpdateFilter(null)}
                tooltip={t('General.ResetFilter')}
              >
                <CloseIcon />
              </IconButton>
            }
          />
        </Grid>
        <CommentsWrapper item xs={12}>
          {comments &&
            comments.length > 0 &&
            comments.map((comment, key) => (
              <CommentContainer
                comment={comment}
                key={key}
                processing={processing}
                onSave={onSave}
                onDelete={onDelete}
                readOnly={readOnly}
              />
            ))}
        </CommentsWrapper>
        <Grid item xs={12}>
          <Button disabled={readOnly || adding || !hasRightToAddComment} onClick={onAdd}>
            {t('Offer.Edit.Comments.AddComment')}
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

CommentsComponent.propTypes = {
  comments: PropTypes.array.isRequired,
  filter: PropTypes.string,
  adding: PropTypes.bool.isRequired,
  processing: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onUpdateFilter: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  hasRightToAddComment: PropTypes.bool
};

export default CommentsComponent;
